import queryString from 'simple-query-string';
import _ from 'lodash';
import { filterAutofill } from '../rogbot/flight-return-oneway/temp-filter-autofill';

export function handleDefaults(defaultObj, dynamicObj) {
	for (const key in dynamicObj) {
		defaultObj[key] = dynamicObj[key];
	}

	return defaultObj;
}

export function getPosition(settings) {
	return new Promise((resolve, reject) => {
		navigator.geolocation.getCurrentPosition(
			(position) => {
				resolve(position);
				return position;
			},
			(error) => {
				reject(error);
			},
			settings
		);
  });
}

export function convertQueryStringToJson() {
	return queryString.parse(location.search);
}

export function convertMinToTime(minutes, format) {
	let hour = String(Math.floor(minutes / 60));
	let min = String(minutes % 60);
	if (hour.length === 1) {
		hour = `0${hour}`;
	}
	if (min.length === 1) {
		min = `0${min}`;
	}

	let result = `${hour}:${min}`;

	if (format) {
		result = format.replace(/HH/ig, hour).replace(/MM/ig, min);
	}

	return result;
}

export function dedupe(flights, keyMap, valMap) {
	const subjectObj = {};
	const finalArr = [];
	const cloned = _.clone(flights);
	const mapped = cloned.map((flight) => {
		const o = {};
		let notation = flight;
		valMap.map((val) => {
			notation = notation[val];
			return val;
		});
		o[keyMap] = notation;
		o.price = flight.pricePoint.price;
		o.checked = false;
		return o;
	});

	_.sortBy(_.uniqBy(mapped, keyMap), keyMap).map((obj) => {
		subjectObj[`count${obj[keyMap]}`] = [];
		subjectObj[`count${obj[keyMap]}`] = mapped.filter((itemObj) => {
			if (itemObj[keyMap] !== obj[keyMap]) {
				return false;
			}
			return itemObj;
		});
		return obj;
	});

	for (const key in subjectObj) {
		finalArr.push(_.minBy(subjectObj[key], 'price'));
	}

	return finalArr;
}

export function checkbox(state, ind) {
	const cloned = _.clone(state);
	if (cloned[ind].checked) {
		cloned[ind].checked = false;
	} else {
		cloned[ind].checked = true;
	}
	return cloned;
}

function random() {
		return Math.floor((1 + Math.random()) * 0x10000)
		.toString(16)
		.substring(1);
}

export function guid() {
    return `${random()}${random()}-${random()}-${random()}-${random()}-${random()}${random()}${random()}`;
}

export function roundFloat(val) {
  return parseFloat(Math.round(val * 100) / 100).toFixed(2);
}

export function generateDayDropdown() {
	return [...Array(31)].map((item, ind) => ({ lab: ind + 1, val: ind + 1 }));
}

export function generateYearDropdown(num, type) {
	const currentYear = new Date().getFullYear();
	let arr;

	if (type === 'minus') {
		arr = [...Array(num)].map((item, ind) => ({ lab: currentYear - ind, val: currentYear - ind }));
	} else {
		arr = [...Array(num)].map((item, ind) => ({ lab: currentYear + ind, val: currentYear + ind }));
	}

	return arr;
}

export function calculateGst(grandTotal, percentage) {
    return Number((grandTotal / (100 + percentage) * percentage).toFixed(2));
}

export function numberToPrice(num, decimalsLength = 2) {
	const price = Number(!isNaN(num) ? num : 0).toFixed(decimalsLength);
	const splitNum = String(price).split('.');
	splitNum[0] = splitNum[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');

	return decimalsLength > 0 ? `${splitNum[0]}.${splitNum[1]}` : splitNum[0];
}

export function stringToNumber(str) {
	return Number(str.replace(/,/ig, ''));
}

export function sortStatesFromCountry(states, code) {
	const cloned = _.clone(states).filter((item) => (item.countryIsoCode === code));
	return cloned.map((item) => ({ lab: item.name, val: item.longStateCode }));
}

export function dashify(str) {
	return str.toLowerCase().replace(' ', '-');
}

export function removeHoldingScreen(elmStr = '.js-holding-screen') {
	const elm = document.querySelector(elmStr);
  try {
    elm.parentElement.removeChild(elm);
  } catch (err) {
		// console.log(err);
  }
}

export function sortJson(json, prop) {
  return json.sort((a, b) => {
		if (a[prop].toLowerCase() < b[prop].toLowerCase()) return -1;
		if (a[prop].toLowerCase() > b[prop].toLowerCase()) return 1;
		return 0;
	});
}

export function rawFetchGet({ dataUrl, username, password, successCallBack }) {
	if (/temp\-fraud\-measure/ig.test(dataUrl)) {
		successCallBack(filterAutofill(dataUrl.split('/')[dataUrl.split('/').length - 1]));

		return;
	}

	fetch(dataUrl, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: 'Basic ' + btoa(username + ':' + password),
		},
		credentials: 'same-origin'
	})
  .then(res => res.json())
  .then(
    payload => {
			successCallBack(payload);
		},
    () => {
			// console.log(error);
		}
  );
}

export function arrayNumberDropdown(num, offset = 0) {
	return [...new Array(num)].map((val, ind) => ({ lab: String(ind + offset), val: String(ind + offset) }));
}

export function stripHTML(html) {
  return html.replace(/<(?:.|\n)*?>|\s/gm, '');
}

export function isLeapYear(year) {
	const yearInt = parseInt(year, 10);
	let leap = false;

	if (yearInt % 4 === 0) {
		if (yearInt % 100 === 0) {
			if (yearInt % 400 === 0) {
				leap = true;
			}
		} else {
			leap = true;
		}
	}

	return leap;
}

export function injectIntoString(string, inject, at) {
	let newValue = string;
	if (newValue.length > at - 1) {
		newValue = [newValue.slice(0, at), inject, newValue.slice(at)].join('');
	}
	return newValue;
}

export function isDotCoDotNz(url = '') {
	return /\.co\.nz/ig.test(`${window.location.href}${url}`);
}

export function nzObject(com, coNz, url = '') {
	return !isDotCoDotNz(url) ? com : coNz;
}

export function intOrZero(value) {
	const intValue = parseInt(value, 10);
	return !isNaN(intValue) ? intValue : 0;
}

export function numberOrZero(value) {
	const number = Number(value);
	return !isNaN(number) ? number : 0;
}

export function getLocalCode() {
	return nzObject('AU', 'NZ');
}

export function getPhoneCode() {
	return nzObject('61', '64');
}

export function phoneNumberFormat(code, number) {
	return `+${code} ${number.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1 ')}`;
}

export function cleanNumber(value) {
    return value.replace(/\D/g, '');
}

export function formatNumber(value) {
	const oriStr = cleanNumber(value);
	const strArr = oriStr.split('');
	[...new Array(Math.floor(strArr.length / 5))].map((interval, ind) => {
		strArr.splice((5 * (ind + 1)) - 1, 0, ' ');
		return ind;
	});
	return strArr.join('');
}

export function isBookingFlow(bookingFlowRouts = []) {
	for (let i = 0; i < bookingFlowRouts.length; i++) {
		if (new RegExp(bookingFlowRouts[i], 'ig').test(window.location.href)) {
			return true;
		}
	}
	return false;
}

export function priceToFlyBuysEarn(price, rate) {
	return parseInt(price / rate, 10);
}

export function priceToFlyBuysBurn(price, rate) {
	return Math.ceil(price * rate, 10);
}

export function localStorageEnabled() {
	try {
		localStorage.setItem('localStorageEnabled', true);
		localStorage.removeItem('localStorageEnabled');
		return true;
	} catch (e) {
		return false;
	}
}

export function isFacebookApplicationCheck() {
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  return (ua.indexOf('FBAN') > -1) || (ua.indexOf('FBAV') > -1);
}
